<template>
  <form @submit.prevent>
    <!-- TKP-235 m.191 (karar 2026-10-28): birim / süreç ekleme ekranındaki gibi sekmeli — Kütüphane ve Yeni İlgili Kişi (ad + kategori
         zorunlu). TKP-236 n.5: "Organizasyon sözlüğünden seç" sekmesi kalktı (organizasyonda açılan kayıt çalışma alanı kütüphanesinde de durur). -->
    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted" data-test="pick-datasubject">
      <b-tab active data-test="datasubject-library-tab">
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
        </template>
        <LibraryItems rightPanelId="sidebar-new-datasubject" organizationScopedState="organizationProcessDataDatasubject" libraryScopedState="datasubject" libraryScopedStateCategory="datasubjectCategory" :hideSaveAs="true" :hideAdvancedFilter="true" @interceptForSetParent="interceptForSetParent" @added="onLibraryAdded" />
      </b-tab>
      <b-tab data-test="datasubject-new-tab">
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("datasubject.new") }}</span>
        </template>
        <sweet-input v-model="newName" type="text" layout="vertical" :placeholder="$t('datasubject.name')" :label="$t('datasubject.name')" data-test="new-datasubject-name" />
        <h6 class="mt-3">{{ $t("common.category") }}</h6>
        <filter-select id="newDatasubjectCategory" ref="newDatasubjectCategory" :placeholder="$t('common.category')" :multiple="false" @filter="onCategorySearch" :selected="category" @changed="(c) => (category = c)" data-test="new-datasubject-category" />
        <sweet-button @click="saveNew()" type="submit" :loading="isUpdating || saving" :disabled="isUpdating || saving || !newName.trim() || !category" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-3" data-test="new-datasubject-save">
          {{ $t("common.save") }}
        </sweet-button>
      </b-tab>
    </b-tabs>
  </form>
</template>

<script>
import { classifySave, savedIdOf, isLibraryPick, isNewEntry, mergeOrgAndLibrary, newEntry, searchRequest, summarizeSaves } from "./unified-picker"; // TKP-184
import LibraryItems from "@cc/library-items"; // TKP-235 m.191
import { createDictionaryEntry } from "./new-dictionary-entry"; // TKP-200 m.13

/** TKP-27 / 6.1 — düğüme ilgili kişi: organizasyondaki kayıt ya da kütüphaneden (yoksa organizasyonda oluşur). Aynı çift 409. */
export default {
  data() {
    return { datasubjects: [], saving: false, category: undefined, newName: "" };
  },
  computed: {
    node() {
      return this.$store.getters["entityBoxes/data"];
    },
    isUpdating() {
      return this.$store.getters["organizationProcessDataDatasubject/isUpdating"];
    },
  },
  components: { LibraryItems },
  methods: {
    /** TKP-236 n.9: kütüphaneden eklenen ilgili kişi de kopyalama sorusunu tetikler (Yeni İlgili Kişi sekmesiyle aynı olay). */
    onLibraryAdded(response) {
      const id = savedIdOf(response);
      if (id) this.$emit("onSave", { savedIds: [id] });
    },
    /** Kütüphane sekmesi: eklenen kalem bu veriye (düğüm) bağlanır. */
    interceptForSetParent(payload) {
      payload.processData = this.node;
    },
    /** TKP-235 m.191: Yeni İlgili Kişi sekmesi — ad + kategori; kayıt Organizasyondan Seç'teki yeni kayıt yoluyla. */
    async saveNew() {
      const entry = newEntry(this.newName);
      if (!entry || !this.category) return;
      this.datasubjects = [entry];
      await this.save();
      if (!this.datasubjects.length) this.newName = "";
    },
    /** TKP-200 m.13: yeni ilgili kişinin kategorisi — organizasyon + kütüphane (kütüphane kalemi sözlükte o anda karşılık bulur). */
    async onCategorySearch(value, callback) {
      const request = searchRequest(value, this.currentLanguage, 200);
      const [org, library] = await Promise.all([
        this.$store.dispatch("organizationDatasubjectCategory/paginate", request),
        this.$store.dispatch("datasubjectCategory/paginateForSearch", request).catch(() => ({ data: { docs: [] } })),
      ]);
      callback(mergeOrgAndLibrary(org.data?.docs ?? [], library.data?.docs ?? []));
    },
    /** Seçilen her ilgili kişi ayrı istek (taslak kapısı öğe başına): organizasyon kaydı doğrudan, kütüphane kalemi "kütüphaneden ekle" yoluyla. */
    async save() {
      const items = this.datasubjects;
      if (!items.length) return;
      this.saving = true;
      try {
        const results = [];
        for (const item of items) {
          try {
            if (isNewEntry(item)) {
              const { fromLibrary, ...category } = this.category || {};
              const process = this.node && this.node.process && typeof this.node.process === "object" ? this.node.process : this.node && this.node.process ? { _id: this.node.process } : undefined;
              const created = await createDictionaryEntry("/datasubject", item.__new, { category, process, language: this.currentLanguage });
              const response = await this.$store.dispatch("organizationProcessDataDatasubject/create", { processData: this.node, datasubject: created });
              results.push({ status: classifySave(response), response });
              continue;
            }
            const response = isLibraryPick(item)
              ? await this.$store.dispatch("organizationProcessDataDatasubject/addFromLibrary", { processData: this.node, libraryItem: { ...item, fromLibrary: undefined } })
              : await this.$store.dispatch("organizationProcessDataDatasubject/create", { processData: this.node, datasubject: item });
            results.push({ status: classifySave(response), response });
          } catch (error) {
            results.push({ status: classifySave(undefined, error), error });
          }
        }
        const summary = summarizeSaves(results);
        const failed = results.find((r) => r.status === "failed");
        if (items.length === 1 && failed) this.$handleHttpErrorByStatusCode(failed.error);
        else this.$toast[summary.failed ? "warning" : "success"](this.$t("process-data.pick.datasubject-done", summary));
        if (summary.created + summary.draft > 0) {
          this.datasubjects = [];
          this.category = undefined;
          this.$emit("onSave", { savedIds: results.map((r) => savedIdOf(r.response)).filter(Boolean) }); // TKP-203: kopyalama önerisi
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
